// @flow
import * as React from 'react'
import styled from 'styled-components'
import moment from 'moment'

import ErrorMessage from '../../components/ErrorMessage'
import Label from '../TextInput/Label'
import colors from '../../styles/colors'
import ReactDatepicker from './Picker'

export const DATE_FORMAT = 'YYYY-MM-DD'

class index extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      inputValue: props.input.value || '',
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const newValue = nextProps.input.value
    if (newValue !== this.props.input.value) {
      this.setState({
        inputValue: newValue ? moment(newValue).format(DATE_FORMAT) : '',
      })
    }
  }

  handleChange = (newDate) => {
    if (newDate === null || newDate.isValid()) {
      this.setState({ inputValue: newDate && newDate.format(DATE_FORMAT) })
      this.props.input.onChange(newDate && newDate.format(DATE_FORMAT))
    }
  }

  onInputBlur = () => {
    if (this.props.input.onBlur) {
      this.props.input.onBlur()
    }
  }

  onInputChange = (event) => {
    this.setState({ inputValue: event.target.value })
  }

  render() {
    const {
      input: { value, onChange, onBlur, ...input },
      minDate,
      maxDate,
      placeholder,
      clearable = false,
      width = 200,
      label,
      showYearDropdown = true,
      scrollableYearDropdown = true,
      yearDropdownItemNumber = 2,
      showMonthDropdown = true,
      openToDate,
      autoComplete = 'off',
      popperPlacement = 'top-start',
      disabled = false,
      readOnly = false,
      errorMessages = {},
      disableValidation = false,
      reference,
    } = this.props
    return (
      <Wrapper $width={width}>
        {label && <Label id={input.name} title={label} />}
        <ReactDatepicker
          id={input.name}
          disabled={disabled}
          readOnly={readOnly}
          ref={reference}
          locale="pl-PL"
          selected={value ? moment(value) : null}
          onChange={this.handleChange}
          minDate={minDate}
          maxDate={maxDate}
          placeholderText={placeholder}
          isClearable={clearable}
          value={this.state.inputValue}
          width={width}
          dateFormat={DATE_FORMAT}
          onChangeRaw={this.onInputChange}
          onBlur={this.onInputBlur}
          openToDate={openToDate}
          showYearDropdown={showYearDropdown}
          yearDropdownItemNumber={yearDropdownItemNumber}
          scrollableYearDropdown={scrollableYearDropdown}
          showMonthDropdown={showMonthDropdown}
          autoComplete={autoComplete}
          popperPlacement={popperPlacement}
          {...input}
        />
        {this.props.children}
        {(this.props.meta.error || this.props.meta.submitError) &&
          this.props.meta.touched &&
          !disableValidation && (
            <ErrorMessage
              errorMessages={errorMessages}
              error={this.props.meta.error || this.props.meta.submitError}
            />
          )}
      </Wrapper>
    )
  }
}

const Wrapper = styled.div`
  position: relative;
  width: ${(props) => (props.$width ? props.$width : 200)}px;
  margin-bottom: 50px;
`

export default index
